import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2 no-underline mb-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  抖漫网页版
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
                {t('footer.description')}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.home')}</Link>
                <Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.category')}</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.about')}</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">热门分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">热血漫画</Link>
                <Link to="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">恋爱漫画</Link>
                <Link to="/category/xuanyi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">悬疑漫画</Link>
                <Link to="/category/gaoxiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">搞笑漫画</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-background-200/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              © {currentYear} 抖漫网页版 | 保留所有权利
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">{t('footer.privacy')}</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">{t('footer.terms')}</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">{t('footer.sitemap')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}